<template>
  <div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="b-title">{{ $route.query.domainName }} 域名解析</div>
        <div class="item" style="margin-left: 20px;">
          <div class="bj-search-row">
            <Button class="bj-search-btn-F85A36" style="margin-right: 20px" @click="onAdd">添加解析记录</Button>
            <Button class="bj-border-F85A36" @click="onBatchDelete">批量删除</Button>
          </div>
        </div>
        </div>
      </div>
    <div class="bj-search-section" style="margin-top: 20px;">
        <Table
          ref="domainTable"
          class="bj-2F3033-table"
          stripe
          :columns="columns"
          :data="data"
          :loading="tableLoading"
        >
          <template slot="status" slot-scope="{ row }">
            <div>
              {{ row.status === 1 ? "正常" : "暂停" }}
            </div>
          </template>
          <template slot="action" slot-scope="{ row }">
            <div class="bj-rows">
              <div class="table-btn" @click="onView(row)">查看</div>
              <div class="table-btn" @click="onEdit(row)">修改</div>
              <div class="table-btn" v-if="row.status == 1" @click="onSuspend(row.id)">暂停</div>
              <div class="table-btn" v-if="row.status == 2" @click="onEnable(row.id)">启用</div>
              <div class="table-btn" v-if="row.status == 2" @click="onDelete(row.id)">删除</div>
            </div>
          </template>
        </Table>
        <div class="page-tool">
          <Page
            class="pages"
            :current="searchObj.page"
            :total="searchObj.total"
            :page-size="searchObj.limit"
            show-total
            show-sizer
            show-elevator
            @on-change="onPageChange"
            @on-page-size-change="onPageSizeChange"
          />
        </div>
    </div>
    <!-- 添加域名解析 -->
    <addAnalysisModal
      :show.sync="addAnalysisModalVisibility"
      :title="$route.query.domainName"
      :type="type"
      :data="analysisData"
      @submit-success="onSuccess"
    ></addAnalysisModal>
    <!-- 查看域名解析 -->
    <showAnalysisModal
      :show.sync="showAnalysisModalVisibility"
      :title="$route.query.domainName"
      :type="1"
      :data="showAnalysisData"
    ></showAnalysisModal>
  </div>
</template>

<script>
import {
  resolutionList,
  resolutionRecordStart,
  resolutionRecordPause,
  resolutionRecordRemove,
} from "api/user.js";
import addAnalysisModal from "components/domain/addAnalysisModal.vue";
import showAnalysisModal from "components/domain/showAnalysisModal.vue";
export default {
  name: "analysis",
  components: {
    addAnalysisModal,
    showAnalysisModal
  },
  data() {
    return {
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 60,
          align: "center",
        },
        {
          title: "主机记录",
          align: "center",
          key: "host",
        },
        {
          title: "记录类型",
          align: "center",
          key: "type",
        },
        {
          width: 170,
          title: "更新时间",
          align: "center",
          key: "updatedTime",
        },
        {
          width: 100,
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          width: 230,
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      searchObj: {
        page: 1,
        limit: 20,
        total: 0,
      },
      data: [],
      tableLoading: false,
      addAnalysisModalVisibility: false,
      type: 0,
      analysisData: {},
      // 查看域名解析记录
      showAnalysisModalVisibility: false,
      showAnalysisData: {},
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          id: this.$route.query.id,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.tableLoading = true;
        const { code, data } = await resolutionList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.onPageChange(1);
    },
    // 查看
    onView(row){
      this.showAnalysisData = {...row};
      this.showAnalysisModalVisibility = true;
    },
    // 启用操作
    onEnable(id) {
      this.$Modal.confirm({
        title: "操作确认",
        content: "<p>确定要开始解析操作吗？</p>",
        onOk: async () => {
          const { code, result } = await resolutionRecordStart(id);
          if (code === 200 && result) {
            this.$Message.success("操作成功!");
            this.req_getList();
          }
        },
      });
    },
    //暂停
    onSuspend(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>您确定要暂停解析操作吗?</p>",
        onOk: async () => {
          const { code, result } = await resolutionRecordPause([id]);
          if (code === 200 && result) {
            this.$Message.success("操作成功!");
            this.req_getList();
          }
        },
        onCancel: () => {},
      });
    },
    // 批量删除事件
    onBatchDelete() {
      const selection = this.$refs.domainTable.getSelection();
      if (selection.length === 0) {
        this.$Message.warning("请选择要删除的域名!");
        return false;
      }
      this.onDeleteReq(selection.map((o) => o.id));
    },
    //删除事件
    onDelete(id) {
      this.onDeleteReq([id]);
    },
    //删除请求
    onDeleteReq(recordIds) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除解析操作吗?</p>",
        onOk: async () => {
          const { code } = await resolutionRecordRemove(recordIds);
          if (code === 200) {
            this.$Message.success("删除成功!");
            this.req_getList();
          }
        },
        onCancel: () => {},
      });
    },
    // 修改
    onEdit(val) {
      this.addAnalysisModalVisibility = true;
      this.type = 1;
      this.analysisData = {...val};
    },
    // 添加解析
    onAdd() {
      this.addAnalysisModalVisibility = true;
      this.type = 0;
      this.analysisData = { id: this.$route.query.id };
    },
    // 添加成功
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
  .bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .b-title{
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    padding: 10px 0;
  }
</style>

